<script lang="ts" setup>
import type { FormDividerInput } from '~/composables/useForm'

const props = defineProps<{
  data: FormDividerInput
}>()

const { dt } = useDirectusTranslation()
</script>

<template>
  <TextWithAfterLine
    :text="dt(props.data.translations)?.text ?? ''"
  />
</template>

<style>

</style>
